<template>
  <div
    class="volume-box"
    :class="{
      'volume-box__h5': isH5,
      'volume-box__h5-landscape': isLandscape,
    }"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <img :src="volumeIcon" alt="" @click="toggleMute" />
    <!-- 桌面端：hover 展开水平滑块 -->
    <div
      v-if="!isH5"
      class="volume-inline-slider"
      :class="{ expanded: isShow }"
    >
      <div class="volume-slider-track">
        <div
          class="volume-slider-fill"
          :style="{ width: volumePercentage + '%' }"
        ></div>
        <input
          type="range"
          min="0"
          :max="100"
          v-model.number="volume"
          @input="onVolumeChange"
          class="volume-slider"
        />
      </div>
    </div>
    <!-- H5 端：保留原有垂直弹出 -->
    <div class="volume-control" v-if="isH5 && isShow">
      <span class="volume-label">{{ volume }}%</span>
      <div class="volume-slider-box">
        <div
          class="progress"
          :style="{
            width: `${volumePercentage >= 100 ? 100 : volumePercentage}%`,
          }"
        ></div>
        <input
          type="range"
          min="0"
          :max="100"
          v-model.number="volume"
          @input="onVolumeChange"
          class="volume-slider"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    // 音量最大百分比 100：100%， 1000，1000%
    maxVolume: {
      type: Number,
      default: 100,
    },
    isLandscape: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      volume: 0, // 初始音量值
      isShow: false,
      volumeIconNo: require("../../../../../assets/images/reply/volume_no.png"),
      volumeIconMedium: require("../../../../../assets/images/reply/volume_medium.png"),
      volumeIconMin: require("../../../../../assets/images/reply/volume_min.png"),
      volumeIconMax: require("../../../../../assets/images/reply/volume_max.png"),
      isH5: isH5(),
    };
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.volume = newValue.toFixed(0);
        } else {
          this.volume = 0;
        }
      },
      immediate: true, // 初始化时同步设置 volume
    },
  },
  mounted() {
    // 监听页面点击其他地方关闭音量控制（仅 H5）
    document.addEventListener("click", this.clickOutside);
    // 监听滚轮音量控制
    document.addEventListener("wheel", this.handleVolumeChange);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutside);
    document.removeEventListener("wheel", this.handleVolumeChange);
  },
  computed: {
    volumePercentage() {
      return (this.volume / 100) * 100 || 0;
    },
    volumeIcon() {
      if (this.volumePercentage === 0) {
        return this.volumeIconNo;
      } else if (this.volume > 0 && this.volume < 30) {
        return this.volumeIconMin;
      } else if (this.volume >= 30 && this.volume < 70) {
        return this.volumeIconMedium;
      } else {
        return this.volumeIconMax;
      }
    },
  },
  methods: {
    handleVolumeChange(e) {
      if (!this.isShow) {
        return;
      }
      if (e.deltaY === 0) {
        return;
      }
      const step = this.maxVolume / 100;
      if (e.deltaY < 0) {
        if (this.volume >= this.maxVolume) {
          this.volume = this.maxVolume;
          return;
        }
        this.volume = +this.volume + step;
      } else {
        if (this.volume <= 0) {
          this.volume = 0;
          return;
        }
        this.volume = +this.volume - step;
      }
      this.$emit("change", this.volume);
      this.$emit("input", this.volume);
    },
    clickOutside(event) {
      if (this.isH5) {
        const target = event.target;
        if (!this.$el.contains(target)) {
          this.isShow = false;
        }
      }
    },
    onMouseEnter() {
      if (!this.isH5) {
        this.isShow = true;
      }
    },
    onMouseLeave() {
      if (!this.isH5) {
        this.isShow = false;
      }
    },
    onVolumeChange(event) {
      this.volume = event.target.value;
      this.$emit("change", this.volume);
      this.$emit("input", this.volume);
    },
    toggleMute() {
      if (this.isH5) {
        this.isShow = !this.isShow;
      } else {
        // 桌面端：点击图标切换静音
        if (this.volume > 0) {
          this._savedVolume = this.volume;
          this.volume = 0;
        } else {
          this.volume = this._savedVolume || 50;
        }
        this.$emit("change", this.volume);
        this.$emit("input", this.volume);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  outline: none;
}
.volume-box {
  position: relative;
  display: flex;
  align-items: center;
  img {
    width: 24px;
    cursor: pointer;
  }
  .volume-inline-slider {
    display: flex;
    align-items: center;
    width: 0;
    overflow: hidden;
    transition: width 0.3s ease;
    margin-left: 8px;

    &.expanded {
      width: 80px;
    }

    .volume-slider-track {
      position: relative;
      width: 64px;
      height: 4px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 2px;

      .volume-slider-fill {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: #fff;
        border-radius: 2px;
      }

      .volume-slider {
        position: absolute;
        left: 0;
        top: -6px;
        width: 100%;
        height: 16px;
        opacity: 0;
        cursor: pointer;
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
      }
    }
  }
}
.volume-box__h5 {
  position: relative;
  img {
    width: 0.5333rem;
    cursor: pointer;
  }
  .volume-control {
    position: absolute;
    top: -3.1rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 1.0667rem;
    height: 2.8rem;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 0.1rem;
    padding: 0.075rem 0;
    .volume-label {
      font-size: 0.4rem;
      color: #ffffff;
      line-height: 0.5333rem;
    }
    .volume-slider-box {
      position: relative;
      width: 1.8rem;
      height: 0.1333rem;
      background: rgba(217, 217, 217, 0.4);
      border-radius: 3px;
      transform: rotate(270deg) translate(-1rem, 0);
      .progress {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #00c89d;
        border-radius: 3px;
      }
      .volume-slider {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 0;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
      }
      .volume-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 0.2667rem;
        height: 0.2667rem;
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      .volume-slider:hover::-webkit-slider-thumb {
        width: 0.32rem;
        height: 0.32rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }

      .volume-slider:active::-webkit-slider-thumb {
        width: 0.32rem;
        height: 0.32rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }
    }
  }
}
.volume-box__h5-landscape {
  position: relative;
  img {
    width: 0.25rem;
    cursor: pointer;
  }
  .volume-control {
    position: absolute;
    top: -2.4rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 0.5625rem;
    height: 1.7rem;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 0.1rem;
    padding: 0.075rem 0;
    .volume-label {
      font-size: 0.175rem;
      color: #ffffff;
      line-height: 0.1875rem;
    }

    .volume-slider-box {
      position: relative;
      width: 1.125rem;
      height: 0.075rem;
      background: rgba(217, 217, 217, 0.4);
      border-radius: 3px;
      transform: rotate(270deg) translate(-0.5625rem, 0);
      .progress {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #00c89d;
        border-radius: 3px;
      }
      .volume-slider {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 0;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
      }
      .volume-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 0.1563rem;
        height: 0.1563rem;
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      .volume-slider:hover::-webkit-slider-thumb {
        width: 0.15rem;
        height: 0.15rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }

      .volume-slider:active::-webkit-slider-thumb {
        width: 0.15rem;
        height: 0.15rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }
    }
  }
}
// ========== PAD 适配（768px ~ 1140px）：放大音量按钮方便触摸操作 ==========
@media screen and (min-width: 768px) and (max-width: 1140px) {
  // --- 桌面浏览器窄窗口 ---
  .volume-box:not(.volume-box__h5):not(.volume-box__h5-landscape) {
    img {
      width: 36px;
    }
    .volume-control {
      width: 68px;
      height: 220px;
      top: -268px;
      padding: 14px 0;
      .volume-label {
        font-size: 16px;
        line-height: 24px;
      }
      .volume-slider-box {
        width: 160px;
        height: 8px;
        border-radius: 4px;
        transform: rotate(270deg) translate(-80px, 0);
        .progress {
          border-radius: 4px;
        }
        .volume-slider::-webkit-slider-thumb {
          width: 20px;
          height: 20px;
        }
        .volume-slider:hover::-webkit-slider-thumb,
        .volume-slider:active::-webkit-slider-thumb {
          width: 26px;
          height: 26px;
        }
      }
    }
  }
}

// ========== PAD 及大屏 H5 变体适配（包含横向/竖向模式，覆盖 rem 为 px） ==========
// min-height: 500px 用于排除手机的横屏模式 (手机横屏 height 通常 < 450px)
@media screen and (min-width: 768px) and (min-height: 500px) {
  .volume-box__h5,
  .volume-box__h5-landscape {
    img {
      width: 24px !important;
      height: 24px !important;
      padding: 6px !important;
      box-sizing: content-box !important;
    }
    .volume-control {
      width: 60px !important;
      height: 200px !important;
      top: -248px !important;
      border-radius: 16px !important;
      padding: 12px 0 !important;
      .volume-label {
        font-size: 16px !important;
        line-height: 22px !important;
      }
      .volume-slider-box {
        width: 150px !important;
        height: 6px !important;
        border-radius: 3px !important;
        transform: rotate(270deg) translate(-75px, 0) !important;
        .progress {
          border-radius: 3px !important;
        }
        .volume-slider::-webkit-slider-thumb {
          width: 15px !important;
          height: 15px !important;
        }
        .volume-slider:hover::-webkit-slider-thumb,
        .volume-slider:active::-webkit-slider-thumb {
          width: 24px !important;
          height: 24px !important;
          border: 5px solid rgba(0, 200, 157, 0.5) !important;
        }
      }
    }
  }
}
</style>

